import React, { useEffect, useState } from "react";
import ProductImageGallery from "./ProductImageGallery";
import {
  Box,
  FormControl,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
  MenuProps as MuiMenuProps,
  Container,
} from "@mui/material";
import ProductDescription from "./ProductDescription";
import OtherAvailableStores from "./OtherAvailableStores";
import flipkart_logo from "../../assets/flipkart-initial.svg";
import amazon_logo from "../../assets/amazon_initial.svg";
import croma_logo from "../../assets/croma-initial.svg";
import jiomart_logo from "../../assets/jiomart-initial.svg";
import reliance_logo from "../../assets/reliancedigital-logo.svg";
import blueArrow from "../../assets/blue-dropdown.svg";

import flipkart_img from "../../assets/flipkartLogo.svg";
import amazon_img from "../../assets/amazon_logo2.svg";
import croma_img from "../../assets/croma_logo.svg";
import jiomart_img from "../../assets/jiomart-logo.svg";
import reliance_img from "../../assets/reliancedigital-logo.svg";
import ProductPriceHistory from "./ProductPriceHistory";
import { useParams } from "react-router-dom";
import { serviceFetchProductDetails } from "../../api/service/services";
import { Retailer, retailersPromise } from "src/utils/retailers_list";

const other_retailers = [
  {
    retailer_name: "Amazon",
    retailer_logo: amazon_logo,
    retailer_img: amazon_img,
    retailer_value: "AMAZON",
  },
  {
    retailer_name: "Flipkart",
    retailer_logo: flipkart_logo,
    retailer_img: flipkart_img,
    retailer_value: "FLIPKART",
  },
  {
    retailer_name: "Jiomart",
    retailer_logo: jiomart_logo,
    retailer_img: jiomart_img,
    retailer_value: "JIOMART",
  },
  {
    retailer_name: "Croma",
    retailer_logo: croma_logo,
    retailer_img: croma_img,
    retailer_value: "CROMA",
  },
  {
    retailer_name: "Reliance_Digital",
    retailer_logo: reliance_logo,
    retailer_img: reliance_img,
    retailer_value: "RELIANCE_DIGITAL",
  },
];

const ProductDetails = () => {
  const customStyles = `
  .image-gallery-slide-wrapper {
    border-radius: 8px;
    background: linear-gradient(white, white) padding-box,
      linear-gradient(180deg, #d3131d 0%, #160f92 100%) border-box;
    border: 0.25px solid transparent;  
    padding: 14px;
    margin:4px;
    }
   
    .image-gallery-thumbnails-wrapper.thumbnails-swipe-horizontal {
      display: flex;
      justify-content: center;
      align-items: center;
      margin:auto;
  }
    .image-gallery-thumbnail {
      border-radius: 8px;
      background: linear-gradient(white, white) padding-box,
        linear-gradient(180deg, #d3131d 0%, #160f92 100%) border-box;
      border: 0.25px solid transparent;
      width: 154px;
      height:124px;
      padding: 4px;
      margin:4px;
   
    }
    .image-gallery-thumbnail.active, .image-gallery-thumbnail:focus {
      border: 3px solid #0F0E96;
    
  }

  .image-gallery-thumbnail .image-gallery-thumbnail-image {
   width:auto;
  }
  .image-gallery-thumbnails-container{
       overflow: auto;
    white-space: nowrap;
    width:96%;
    margin-left:12px;
    margin-right:12px;
  }
 
.image-gallery-thumbnails-container::-webkit-scrollbar {
  height: 6px; /* height of the scrollbar */
}

.image-gallery-thumbnails-container::-webkit-scrollbar-thumb {
  background-color:#d2d1ff; /* color of the thumb */
  border-radius: 5px; /* border radius of the thumb */
  width: 4px; /* width of the thumb */
}

.image-gallery-thumbnails-container::-webkit-scrollbar-track {
  background-color:  #ffffff; /* color of the track */
 width:6px; /* width of the track */
}

.image-gallery-image {
  width: 100%;
  height: auto;
  max-height: 500px; /* Set a max height for larger images */
  object-fit: contain; /* Maintain aspect ratio */
}
  `;

  const { id } = useParams(); // Get the id from the URL
  const [imageUrlColorPicker, setImageUrlColorPicker] = useState<string>("");
  const [otherRetailer, setOtherRetailer] = useState("");
  const [productDetails, setProductDetails] = useState<any>({});
  const [productInfo, setProductInfo] = useState<any>({});
  const [productImageGallery, setProductImageGallery] = useState<any>([]);
  const [open, setOpen] = useState(false);
  const [selectedRetailer, setSelectedRetailer] = useState<any>({});
  const [otherRetailers, setOtherRetailers] = useState<any[]>([]);
  const [priceHistory, setPriceHistory] = useState([]);

  useEffect(() => {
    if (id) {
      serviceFetchProductDetails(id).then((response) => {
        setProductDetails(response?.data);
      });
    }
  }, [id]);

  useEffect(() => {
    const retailers = productDetails?.other_retailers || [];

    if (Array.isArray(retailers) && retailers.length > 0) {
      const sortedRetailers = [...retailers].sort(
        (a, b) =>
          parseFloat(a.product_discounted_price) -
          parseFloat(b.product_discounted_price)
      );

      const topRetailer = sortedRetailers[0];
      const remainingRetailers = sortedRetailers.slice(1);

      setSelectedRetailer(topRetailer);
      setOtherRetailers(remainingRetailers);
    }
  }, [productDetails]);

useEffect(() => {
  if (!selectedRetailer || !productDetails) return;

  const loadRetailerLogo = async () => {
    let retailerLogo: string | undefined;

    const retailers = await retailersPromise;

    const retailer = retailers.find(
      (item: Retailer) =>
        item.retailer_name.toLowerCase() ===
        selectedRetailer.retailer?.toLowerCase()
    );

    retailerLogo = retailer?.retailer_logo;

    setProductInfo({
      product_title: productDetails.title,
      product_price: selectedRetailer.product_discounted_price,
      product_color: productDetails.product_color,
      product_description: productDetails.product_description,
      product_memory: productDetails.product_memory,
      product_storage: productDetails.product_storage,
      product_url: selectedRetailer.product_url_retailer,
      retailer_logo: retailerLogo,
    });

    setProductImageGallery(
      selectedRetailer.product_images
        ? selectedRetailer.product_images.split(", ")
        : []
    );
  };

  loadRetailerLogo();
}, [selectedRetailer, productDetails]);


  useEffect(() => {
    setImageUrlColorPicker(productImageGallery[0]);
  }, [productImageGallery]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const MenuProps: Partial<MuiMenuProps> = {
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left",
    },
    onClose: handleClose,
    open,
  };

  const handleChange = (event: SelectChangeEvent) => {
    setOtherRetailer(event.target.value as string);
    handleClose();
  };

  const handleClick = (days: string) => console.log(`Selected ${days} days`);

  return (
    <Container maxWidth="xl" className="container">
      <style>{customStyles}</style>
      <Grid container spacing={3} paddingTop={1}>
        <Grid item xs={12} md={7}>
          <ProductImageGallery images={productImageGallery} />
        </Grid>
        <Grid item xs={12} md={5}>
          <ProductDescription
            productData={productInfo}
            imageUrl={imageUrlColorPicker}
          />
        </Grid>

        {otherRetailers && otherRetailers.length > 0 && (
          <>
            <Grid item xs={12}>
              <Typography
                id="blogs-section"
                align="left"
                className="title-styles"
              >
                Other Available Stores +
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <OtherAvailableStores otherRetailersData={otherRetailers} />
            </Grid>
          </>
        )}

        {priceHistory && priceHistory.length > 0 && (
          <>
            <Grid item xs={12} md={6}>
              <Typography
                id="blogs-section"
                align="left"
                className="title-styles"
              >
                Price Change History
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ marginTop: "20px" }}>
                <FormControl fullWidth size="small">
                  <Select
                    labelId="retailers-list"
                    id="select-retailer"
                    value={otherRetailer}
                    onChange={handleChange}
                    IconComponent={() => (
                      <img
                        src={blueArrow}
                        alt="down-arrow"
                        style={{
                          padding: "20px",
                          cursor: "pointer",
                          transform: open ? "rotate(180deg)" : "rotate(0deg)",
                          transition: "transform 0.3s",
                        }}
                        onClick={handleOpen}
                      />
                    )}
                    MenuProps={MenuProps}
                    sx={{
                      borderRadius: "8px",
                      height: "42px",
                      fontFamily: "Poppins Regular",
                      fontSize: "15px",
                      color: "#000000",
                      background:
                        "linear-gradient(white, white) padding-box,linear-gradient(180deg, #d3131d 0%, #160f92 100%) border-box",
                      border: "0.25px solid transparent",
                      "&:focus": {
                        border: "0.25px solid transparent",
                      },
                      "&:hover": {
                        border: "0.25px solid transparent",
                      },
                      "& .MuiSelect-select": {
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      },
                    }}
                  >
                    {other_retailers.map((retailer, index) => (
                      <MenuItem
                        key={index}
                        value={retailer.retailer_value}
                        onClick={() =>
                          console.log(`Selected ${retailer.retailer_value}`)
                        }
                      >
                        <img
                          src={retailer.retailer_logo}
                          alt={retailer.retailer_name}
                          style={{
                            paddingRight: "10px",
                          }}
                        />
                        {retailer.retailer_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <ProductPriceHistory
              /*    handleClick={handleClick}
                priceHistoryData={priceHistory} */
              />
            </Grid>
          </>
        )}
      </Grid>
    </Container>
  );
};

export default ProductDetails;
